import { t } from 'ember-intl';
import type { TOC } from '@ember/component/template-only';
import { DrawerHeader, DrawerBody } from 'tio-reimagined/components/drawer';
import type TasApplicationModel from 'tio-data/models/tas-application';
import type TasProgramInstanceModel from 'tio-data/models/tas-program-instance';
import type { TasClaimsFinancials } from '../../../../types/tuition-assistance.ts';
import FinancialDetailsContent from '../financial-details-content.gts';

/**
 * Financial Details drawer component
 *
 * Lightweight drawer wrapper that provides the drawer context and delegates
 * to FinancialDetailsContent for the actual financial summary display and editing.
 */
export interface FinancialDetailsDrawerSignature {
  Args: {
    application: TasApplicationModel;
    programInstance: TasProgramInstanceModel;
    // State (minimal)
    editableApplicationTotal: number;
    editableCourseCashTotal: number;
    // Readonly view flag
    isReadonlyView: boolean;
    // Callbacks
    onUpdateApprovedTotal: (total: number, reason: string) => Promise<void>;
    onSaveClaimsFinancials: (financials: TasClaimsFinancials, reason: string) => Promise<void>;
    onUpdateClaimsFinancials: (financials: TasClaimsFinancials) => void;
    onSetApplicationTotal: (total: number) => void;
    onSetCourseCashTotal: (total: number) => void;
    onInvoiceDateChange: (date: string) => void;
  };
}

const FinancialDetailsDrawer: TOC<FinancialDetailsDrawerSignature> = <template>
  <div class="flex flex-col h-full">
    <DrawerHeader>
      <h2 class="text-lg font-semibold text-gray-800">
        {{t "tuition_assistance.application_approval.financial_details"}}
      </h2>
    </DrawerHeader>

    <DrawerBody>
      <FinancialDetailsContent
        @application={{@application}}
        @programInstance={{@programInstance}}
        @editableApplicationTotal={{@editableApplicationTotal}}
        @editableCourseCashTotal={{@editableCourseCashTotal}}
        @isReadonlyView={{@isReadonlyView}}
        @onUpdateApprovedTotal={{@onUpdateApprovedTotal}}
        @onSaveClaimsFinancials={{@onSaveClaimsFinancials}}
        @onUpdateClaimsFinancials={{@onUpdateClaimsFinancials}}
        @onSetApplicationTotal={{@onSetApplicationTotal}}
        @onSetCourseCashTotal={{@onSetCourseCashTotal}}
        class="h-full"
      />
    </DrawerBody>
  </div>
</template>;

export default FinancialDetailsDrawer;
